import { AlfrescoApiService } from '@alfresco/adf-core';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PreviewContractService {

  constructor(private apiService: AlfrescoApiService) { }

  getAppovedImage() {
    // eslint-disable-next-line max-len
    return 'data:image/jpeg;base64,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';
  }


  toolbarSettings = {
    showTooltip: true,
    showText: true,
    toolbarItems: [
      // "OpenOption",
      'UndoRedoTool',
      'PageNavigationTool',
      'MagnificationTool',
      'PanTool',
      'SelectionTool',
      'SubmitForm',
      'FreeTextAnnotationOption',
      'InkAnnotationOption',
      'ShapeAnnotationOption',
      'StampAnnotation',
      'SignatureOption',
      'SearchOption',
      'DownloadOption'
    ],
    annotationToolbarItems: [
      'HighlightTool',
      'UnderlineTool',
      'StrikethroughTool',
      'ColorEditTool',
      'OpacityEditTool',
      'AnnotationDeleteTool',
      'StampAnnotationTool',
      'HandWrittenSignatureTool',
      'InkAnnotationTool',
      'ShapeTool',
      'CalibrateTool',
      'StrokeColorEditTool',
      'ThicknessEditTool',
      'FreeTextAnnotationTool',
      'FontFamilyAnnotationTool',
      'FontSizeAnnotationTool',
      'FontStylesAnnotationTool',
      'FontAlignAnnotationTool',
      'FontColorAnnotationTool',
    ]
  };

  getToolbarSetting() {
    return this.toolbarSettings;
  }


  // getOffsetX() {
  //   const pageWidth = 595;
  //   const stampWidth = 100;
  //   const offsetX = pageWidth - stampWidth - 70;
  //   return offsetX;
  // }


  // getOffsetY() {
  //   const pageHeight = 842;
  //   const stampHeight = 50;
  //   const originalOffsetY = pageHeight - stampHeight - 70;
  //   const offsetY = originalOffsetY + 80;
  //   return offsetY;
  // }

  getPageWidth() {
    const pageWidth = 595;
    return pageWidth;
  }

  getPageHeight() {
    const pageHeight = 842;
    return pageHeight;
  }


  private publicApiCall(path: string, httpMethod: string, params?: any[]): Promise<any> {
    return this.apiService.getInstance().contentClient.callApi(path, httpMethod, ...params);
  }


  getNodes(nodeID: string): Observable<any> {
    const pathService = `/nodes/${nodeID}`
    const httpMethod = 'GET';
    return from(this.publicApiCall(pathService, httpMethod, [{}, {}, {}, {}, {}, ['application/json'], ['application/json']]));
  }

  async getNonPdfActive(nodeId: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.getNodes(nodeId).subscribe({
        next: (data) => {
          const fileName = data.entry.name;

          const fileExtension = fileName.split('.').pop();


          const isNotPdf = fileExtension !== 'pdf';



          resolve(isNotPdf);
        },
        error: (error) => {
          console.log('error getMimeType: ', error);
          reject(false);
        }
      });
    });
  }

  getRenditionsInfo(nodeId: string, renId: string): Observable<any> {
    const pathService = `/nodes/${nodeId}/renditions/${renId}`
    const httpMethod = 'GET';
    return from(this.publicApiCall(pathService, httpMethod, [{}, {}, {}, {}, {}, ['application/json'], ['application/json']]));
  }

  async getCheckRenditions(nodeId: string, renId: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {

      const attemptGetRenditionsInfo = () => {
        this.getRenditionsInfo(nodeId, renId).subscribe({
          next: (data) => {
            const status = data.entry.status;
            console.log('getCheckRenditions status: ', status);
            if (status === 'CREATED') {
              resolve(true);
            } else {
              resolve(false); // Resolve false after max retries
            }
          },
          error: (error) => {
            console.log('error getMimeType: ', error);
            reject(false);
          }
        });
      };
      attemptGetRenditionsInfo(); // Initial attempt
    });
  }

  createRendition(nodeId: string, renId: string): Observable<any> {
    const pathService = `/nodes/${nodeId}/renditions`
    const httpMethod = 'POST';
    const body = { 'id': renId }
    return from(this.publicApiCall(
      pathService,
      httpMethod,
      [null, null, null, null, body, ['application/json'], ['application/json']]
    ));
  }

  async createRenditionData(nodeId: string, renId: string): Promise<boolean> {

    console.log('# createRenditionData');

    return new Promise<boolean>((resolve, reject) => {
      const attemptCreateRendition = () => {
        this.createRendition(nodeId, renId).subscribe({
          next: (data) => {
            if (data.status === 202) {
              console.log('createRenditionData success:', data);
              resolve(true);
            } else {
              console.log('createRenditionData acepted');
              resolve(true);
            }
          },
          error: (error) => {
            if ([400, 401, 403, 404, 501].includes(error.status)) {
              console.error('Error occurred with status', error.status, ':', error.error);
              reject(error);
            } else if (error.status === 409) {
              console.error('All renditions requested already exist:', error.error);
              resolve(true);
            } else {
              console.error('Error occurred:', error);
              setTimeout(() => {
                attemptCreateRendition(); // Retry after 3 seconds
              }, 3000);
            }
          }
        });
      };
      attemptCreateRendition(); // Initial attempt
    });
  }


  async getRetryCheckRenditions(nodeId: string, renId: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const attemptGetRenditionsInfo = () => {
        this.getRenditionsInfo(nodeId, renId).subscribe({
          next: (data) => {
            const status = data.entry.status;
            console.log('getRetryCheckRenditions status: ', status);
            if (status === 'CREATED') {
              resolve(true);
            } else {
              resolve(false); // Resolve false after max retries
            }
          },
          error: (error) => {
            console.log('error getMimeType: ', error);
            reject(false);
          }
        });
      };
      attemptGetRenditionsInfo(); // Initial attempt
    });
  }


  getRenditionContent(nodeId: string, renId: string): Promise<any> {
    const pathService = `/nodes/${nodeId}/renditions/${renId}/content?attachment=true&placeholder=false`;
    const httpMethod = 'GET';
    return this.publicApiCall(pathService, httpMethod, [null, null, null, null, null, ['application/json'], ['blob'], null, null, 'blob'])
      .then((response: any) => {
        if (response instanceof Blob) {
          return this.blobToBase64(response);
        } else {
          return Promise.reject(new Error('Response is not of type Blob'));
        }
      });
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        const base64Content = base64String.split(';base64,')[1];
        resolve(base64Content);
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(blob);
    });
  }


  downloadNode(nodeId: string): Promise<any> {
    const pathService = `/nodes/${nodeId}/content?attachment=true`;
    const httpMethod = 'GET';
    return this.publicApiCall(pathService, httpMethod, [null, null, null, null, null, ['application/json'], ['blob'], null, null, 'blob'])
      .then((response: any) => {
        if (response instanceof Blob) {
          return this.blobToBase64Edit(response);
        } else {
          return Promise.reject(new Error('Response is not of type Blob'));
        }
      });
  }

  private async blobToBase64Edit(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        resolve(base64String);
      };

      reader.onerror = () => {
        reader.abort();
        reject(new DOMException('Failed to read the blob.'));
      };

      reader.readAsDataURL(blob);
    });
  }

}

